/* @flow */

import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { Form, FormGroup, Row, Col, Button } from 'react-bootstrap'
import { Link } from 'react-router'
import VipSuccess from './VipSuccess'
import FormInput from './FormInput'

const AddVipForm = ({
  handleSubmit,
  pristine,
  isPosting,
  separate,
  postError,
  vipData
}: {
  handleSubmit: Function,
  pristine: boolean,
  isPosting: Function,
  separate: boolean,
  postError: string,
  vipData: {
    pubId: number,
    userId: string,
    siteConfigId: number
  }
}) => (
  vipData ?
    <VipSuccess {...vipData} /> :
    <div>
      <Row>
        <Col sm={10} smOffset={1} className="text-center">
          <h1>Create new VIP publisher account</h1>
          <h4>Note: Converting an account with shared users to a custom URL?
            Use <Link to="/vip/convert">this</Link> form instead.</h4>
          <h2 style={{ minHeight: '50px', color: 'red' }}>
            { postError || '' }
          </h2>
        </Col>
      </Row>
      <Form horizontal onSubmit={handleSubmit}>
        <Field
          type="text"
          name="siteName"
          label="Site Name"
          component={FormInput}
          placeholder="vip-example"
          className="form-control"
          required
        />
        <Field
          type="checkbox"
          name="separateUsers"
          label="Separate Users?"
          component={FormInput}
          normalize={ v => !!v }
        />
        <Field
          type="text"
          name="orgName"
          label="Org Name"
          component={FormInput}
          className="form-control"
          required
        />
        <Field
          type="email"
          name="orgEmail"
          label={ !separate ? 'Org Email' : 'New User/Org Email' }
          component={FormInput}
          placeholder="dev+vip@submishmash.com"
          className="form-control"
          required
        />
        {
          !separate ?
            <Field
              type="text"
              name="userId"
              label="Existing User ID"
              component={FormInput}
              placeholder="D54EDE86-A76F-4E3B-9804-E6A38BADB44C"
              className="form-control"
              required
            /> : ''
        }
        <Field
          type="text"
          name="orgPhone"
          label="Org Phone"
          component={FormInput}
          placeholder="555-555-5555"
          className="form-control"
        />
        <Field
          type="text"
          name="orgUrl"
          label="Org URL"
          component={FormInput}
          placeholder="www.example.com"
          className="form-control"
        />
        <Field
          type="text"
          name="domain"
          label="Domain"
          component={FormInput}
          placeholder="example.submittable.com"
          className="form-control"
          required
        />
        <Field
          type="text"
          name="extDomain"
          label="External Domain"
          component={FormInput}
          className="form-control"
        />
        {
          separate ?
            <Field
              type="checkbox"
              name="extAuth"
              label="Enable external auth?"
              component={FormInput}
              normalize={ v => !!v }
            /> :
            ''
        }
        <FormGroup>
          <Col smOffset={4} sm={4}>
            <Button type="submit" disabled={pristine || isPosting}>
              Create VIP
            </Button>
          </Col>
        </FormGroup>
      </Form>
    </div>
)

export default reduxForm({
  form: 'addVip',
  initialValues: {
    separateUsers: false,
    enableExtAuth: false
  }
})(AddVipForm)



// WEBPACK FOOTER //
// ./src/components/AddVipForm.js